import { Cancel, Check } from '@mui/icons-material'
import { Box, Button, CircularProgress } from '@mui/material'
import { ReactElement } from 'react'

interface CancelSaveButtonsProps {
  moduleName: string
  canSubmit: boolean
  isSubmitting: boolean
  isDisabled: boolean
  handleSave: () => void
  handleCancel: () => void
}

export default function CancelSaveButtons({
  moduleName,
  canSubmit,
  isSubmitting,
  isDisabled,
  handleSave,
  handleCancel,
}: CancelSaveButtonsProps): ReactElement {
  return (
    <Box className="flex flex-wrap gap-3 mt-4 md:flex-nowrap md:justify-end">
      <Button
        className="basis-full md:basis-auto"
        variant="outlined"
        onClick={handleCancel}
        size="large"
        startIcon={<Cancel />}
        disabled={isDisabled}
        aria-label="Cancel"
      >
        Cancel
      </Button>
      <Button
        type="submit"
        variant="contained"
        size="large"
        startIcon={
          isSubmitting ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            <Check />
          )
        }
        disabled={!canSubmit || isSubmitting || isDisabled}
        aria-label={`Save ${moduleName}`}
        onClick={handleSave}
      >
        {isSubmitting ? 'Saving...' : `Save ${moduleName}`}
      </Button>
    </Box>
  )
}
